/* ==========================================================================
   Generic horizontal slider (product carousels) + carousel tabs
   ========================================================================== */
(function () {
  'use strict';

  function initSlider(slider) {
    var track = slider.querySelector('[data-slider-track]');
    var prevBtn = slider.querySelector('[data-slider-prev]');
    var nextBtn = slider.querySelector('[data-slider-next]');
    if (!track) return;

    function scrollByAmount(direction) {
      var slide = track.querySelector(':scope > *');
      var slideWidth = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth / 2;
      track.scrollBy({ left: direction * slideWidth * 2, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByAmount(1); });
  }

  function initAll() {
    document.querySelectorAll('slider-component').forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  /* ---- Product carousel tabs ---- */
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-carousel-tab]');
    if (!tab) return;
    var tabsWrapper = tab.closest('.product-carousel__tabs');
    var carousel = tab.closest('.product-carousel');
    if (!tabsWrapper || !carousel) return;

    tabsWrapper.querySelectorAll('[data-carousel-tab]').forEach(function (t) {
      t.classList.remove('product-carousel__tab--active');
      t.setAttribute('aria-selected', 'false');
    });
    tab.classList.add('product-carousel__tab--active');
    tab.setAttribute('aria-selected', 'true');

    var targetId = tab.getAttribute('data-target');
    carousel.querySelectorAll('.product-carousel__panel').forEach(function (panel) {
      var isTarget = panel.id === targetId;
      panel.hidden = !isTarget;
      panel.classList.toggle('product-carousel__panel--active', isTarget);
    });
  });

  /* ---- Announcement bar autoplay ---- */
  document.querySelectorAll('[data-announcement-bar][data-announcement-autoplay]').forEach(function (bar) {
    var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-announcement-slide]'));
    if (slides.length < 2) return;
    var seconds = parseInt(bar.getAttribute('data-announcement-autoplay'), 10) || 5;
    var index = 0;
    setInterval(function () {
      slides[index].hidden = true;
      index = (index + 1) % slides.length;
      slides[index].hidden = false;
    }, seconds * 1000);
  });
})();
